import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";

export const blizzardBucks = {
  id: "blizzard-bucks",
  name: "Blizzard Bucks",

  colorScheme: {
    tileColors: [
      { background: "#32b5ff", text: "#fff" },
      { background: "#0085d1", text: "#fff" },
      { background: "#01639b", text: "#fff" },
      { background: "#023f62", text: "#fff" },
    ],
    overlayPattern: overlay,
    overlayColor: "#01304b",
    scratchColor: "#0079bd",

    controlColor: "#0079bd",
    onControlColor: "#fff",
  },

  nameImage: name,
  background: background,
  card: background,

} satisfies GameTheme;
